import { ProgressTracker, type Stages } from '@atlaskit/progress-tracker';

interface ProgressProps {
    items: Stages;
}

const Progress = ({ items }: ProgressProps) => <ProgressTracker items={items} />;

export default Progress;